import { COMMON_VALUES_EVENTS } from './constants';
import {
  EventData,
  EventAction,
  Action,
  ScreenAction
} from 'src/analytics/types';

const actionToEventDataMap: Record<ScreenAction, Action> = {
  [ScreenAction.REDIRECT_TO_HP_ID]: Action.screenDisplayed,
  [ScreenAction.BACK_FROM_HP_ID]: Action.screenDisplayed,
  [ScreenAction.REDIRECT_TO_TENANT_SELECTOR]: Action.screenDisplayed,
  [ScreenAction.BACK_FROM_TENANT_SELECTOR]: Action.screenDisplayed,
  [ScreenAction.REDIRECT_TO_SAFETY_NET_SCREEN_ERROR]: Action.screenDisplayed,
  [ScreenAction.COMPLETED]: Action.screenDisplayed,
  [ScreenAction.UNRECOVERABLE_SCREEN_ERROR]: Action.screenDisplayed,
  [ScreenAction.UNRECOVERABLE_SCREEN_ERROR_ACKNOWLEDGE]:
    Action.controlButtonClicked
};

export const getEventData = (action: EventAction): EventData => {
  const eventAction = actionToEventDataMap[action?.type];
  if (!eventAction) {
    throw new Error('Event data not found for action type');
  }
  return {
    ...COMMON_VALUES_EVENTS,
    screenName: getScreenName(action),
    action: eventAction,
    ...action.payload
  };
};

const screenNameMap: Record<ScreenAction, string> = {
  [ScreenAction.REDIRECT_TO_HP_ID]: 'RedirectToHpId',
  [ScreenAction.BACK_FROM_HP_ID]: 'BackFromHpId',
  [ScreenAction.REDIRECT_TO_TENANT_SELECTOR]: 'RedirectToTenantSelector',
  [ScreenAction.BACK_FROM_TENANT_SELECTOR]: 'BackFromTenantSelector',
  [ScreenAction.REDIRECT_TO_SAFETY_NET_SCREEN_ERROR]:
    'RedirectToSafetyNetScreenError',
  [ScreenAction.UNRECOVERABLE_SCREEN_ERROR]: 'UnrecoverableScreenError',
  [ScreenAction.UNRECOVERABLE_SCREEN_ERROR_ACKNOWLEDGE]:
    'UnrecoverableScreenError',
  [ScreenAction.COMPLETED]: 'Completed'
};

export const getScreenName = (action: EventAction): string => {
  const screenName = screenNameMap[action?.type];
  if (!screenName) {
    throw new Error('Screen name not found for action type');
  }
  return screenName;
};
